module.exports = __webpack_public_path__ + "img/4.6a7f51b4.png";